function Map() {
  return (
    <iframe
      title="Map to Blanchard Horton PLLC"
      src="https://www.google.com/maps?q=40%20New%20York%20Avenue%20Suite%20300%20Oak%20Ridge%20TN%2037830&output=embed"
      width="100%"
      height="420"
      style={{ border: 0 }}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      allowFullScreen
    />
  )
}

export default Map
